import React from 'react';

import { Button, ButtonProps } from '../Button/Button';
import { Icon } from '../Icon';
import { PopupMenu, MenuItemType } from './PopupMenu';

type OwnProps = {
  zIndex?: number;
  items: MenuItemType[];
  menuTestId?: string;
};

type Props = OwnProps & Omit<ButtonProps, 'endIcon' | 'onClick'>;

export const PopupButton = ({
  zIndex,
  items,
  menuTestId,
  children,
  ...buttonProps
}: Props) => {
  return (
    <PopupMenu
      zIndex={zIndex}
      testId={menuTestId}
      trigger={({ isOpen, ...triggerProps }) => (
        <Button
          endIcon={<Icon name={isOpen ? 'chevron-up' : 'chevron-down'} />}
          {...buttonProps}
          {...triggerProps}
        >
          {children}
        </Button>
      )}
      items={items}
    />
  );
};

export default PopupButton;
